<template>
  <div class="business-evaluation">
    <div class="business-evaluation.header">
      <el-input
        placeholder="请输入姓名"
        v-model="name"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <el-input
        placeholder="请输入专家类型"
        v-model="expertType"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <el-input
        placeholder="请输入职称"
        v-model="jobTitle"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <el-input
        placeholder="请输入研究领域"
        v-model="fieldStudy"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <label style="margin-right:10px;line-height:40px;min-width:60px;">审核状态:</label>
      <el-select v-model="status" placeholder="请选择审核状态" @change="search" clearable>
        <el-option
          v-for="item in typeOptions"
          :key="item.id"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <Table
      :table="table"
      :url="url"
      @acceptanceFun="acceptanceFun"
      @editFun="editFun"
      @detailsFun="detailsFun"
      ref="children"
      :tableParams="tableParams"
    ></Table>
    <el-dialog title="专家入库登记" :visible.sync="dialogFormVisible" :modal-append-to-body="false">
      <el-form ref="form" :model="form" label-width="180px" :rules="rules" style="margin-top: 20px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名：" prop="name">
              <el-input
                v-model="form.name"
                :disabled="operate !== 'add'"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别：" prop="sex">
              <el-select
                :popper-append-to-body="false"
                v-model="form.sex"
                placeholder="请选择性别"
                style="width: 100%"
                :disabled="operate !== 'add'"
              >
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="出生日期：" prop="birthday">
              <el-date-picker
                :append-to-body="false"
                v-model="form.birthday"
                :disabled="operate !== 'add'"
                type="date"
                value-format="yyyy-MM-dd"
                :key="1"
                placeholder="选择出生日期"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="民族：">
              <el-input
                v-model="form.ethnic"
                :disabled="operate !== 'add'"
                placeholder="请输入民族"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="国籍：">
              <el-input
                v-model="form.nationality"
                :disabled="operate !== 'add'"
                placeholder="请输入国籍"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="籍贯：">
              <el-input
                v-model="form.nativePlace"
                :disabled="operate !== 'add'"
                placeholder="请输入籍贯"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="出生地：">
              <el-input
                v-model="form.birthplace"
                :disabled="operate !== 'add'"
                placeholder="请输入出生地"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="省内外专家：">
              <el-input
                v-model="form.expert"
                :disabled="operate !== 'add'"
                placeholder="请输入省内外专家"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="证件类型：">
              <el-select
                :popper-append-to-body="false"
                v-model="form.documentType"
                :disabled="operate !== 'add'"
                placeholder="请选择证件类型"
                style="width: 100%"
              >
                <el-option label="‌居民身份证" value="‌居民身份证"></el-option>
                <el-option label="临时居民身份证‌" value="临时居民身份证‌"></el-option>
                <el-option label="护照‌" value="护照‌"></el-option>
                <el-option label="军人身份证件‌" value="军人身份证件‌"></el-option>
                <el-option label="港澳台居民居住证" value="港澳台居民居住证"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件号码：">
              <el-input
                v-model="form.idNumber"
                :disabled="operate !== 'add'"
                placeholder="请输入证件号码"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所学专业：">
              <el-input
                v-model="form.major"
                :disabled="operate !== 'add'"
                placeholder="请输入所学专业"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="现从事专业：" prop="currentProfession">
              <el-input
                v-model="form.currentProfession"
                :disabled="operate !== 'add'"
                placeholder="请输入现从事专业"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产业领域：">
              <el-input
                v-model="form.industry"
                :disabled="operate !== 'add'"
                placeholder="请输入产业领域"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位类型：">
              <el-select
                style="width: 100%;"
                v-model="form.unitType"
                :disabled="operate !== 'add'"
                placeholder="请选择单位类型"
              >
                <el-option label="科研院所" value="科研院所"></el-option>
                <el-option label="事业单位" value="事业单位"></el-option>
              </el-select>

              <!-- <el-input
                v-model="form.unitType"
                :disabled="operate !== 'add'"
                placeholder="请输入单位类型"
              ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="工作单位：" prop="workplace">
              <el-input
                v-model="form.workplace"
                :disabled="operate !== 'add'"
                placeholder="请输入工作单位"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工作单位组织机构代码：">
              <el-input
                v-model="form.workplaceCode"
                :disabled="operate !== 'add'"
                placeholder="请输入工作单位组织机构代码"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="职务：">
              <el-input
                v-model="form.position"
                :disabled="operate !== 'add'"
                placeholder="请输入职务"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属地区：" prop="region">
              <el-cascader
                size="large"
                :options="addroptions"
                v-model="form.region"
                placeholder="请选择省市区"
                :disabled="operate !== 'add'"
                clearable
                style="width: 100%"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="职称：" prop="jobTitle">
              <el-input
                v-model="form.jobTitle"
                :disabled="operate !== 'add'"
                placeholder="请输入职称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="现职称取得时间：">
              <el-date-picker
                :append-to-body="false"
                v-model="form.getJobTitleDate"
                :disabled="operate !== 'add'"
                type="date"
                value-format="yyyy-MM-dd"
                :key="1"
                placeholder="选择现职称取得时间"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="专家库：" prop="expertDatabase">
              <el-input
                v-model="form.expertDatabase"
                :disabled="operate !== 'add'"
                placeholder="请输入专家库"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专家类型：" prop="expertType">
              <el-input
                v-model="form.expertType"
                :disabled="operate !== 'add'"
                placeholder="请输入专家类型"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="人才称号：" prop="talentTitle">
              <el-input
                v-model="form.talentTitle"
                :disabled="operate !== 'add'"
                placeholder="请输入人才称号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="推荐单位：" prop="recommendedUnits">
              <el-input
                v-model="form.recommendedUnits"
                :disabled="operate !== 'add'"
                placeholder="请输入推荐单位"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="研究领域：" prop="fieldStudy">
              <el-input
                v-model="form.fieldStudy"
                :disabled="operate !== 'add'"
                placeholder="请输入研究领域"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮政编码：">
              <el-input
                v-model="form.postalCode"
                :disabled="operate !== 'add'"
                placeholder="请输入邮政编码"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="工作电话：" prop="workPhone">
              <el-input
                v-model="form.workPhone"
                :disabled="operate !== 'add'"
                placeholder="请输入工作电话"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="移动电话：" prop="mobilePhone">
              <el-input
                v-model="form.mobilePhone"
                :disabled="operate !== 'add'"
                placeholder="请输入移动电话"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="电子邮箱：" prop="email">
              <el-input
                v-model="form.email"
                :disabled="operate !== 'add'"
                placeholder="请输入电子邮箱"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="通信地址：" rop="mailingAddress">
              <el-input
                v-model="form.mailingAddress"
                :disabled="operate !== 'add'"
                placeholder="请输入通信地址"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="学术或社会团体任职或兼职情况：">
              <el-input
                type="textarea"
                :disabled="operate !== 'add'"
                :autosize="{ minRows: 6, maxRows: 6 }"
                placeholder="请输入"
                v-model="form.conditions"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <span style="font-size: 16px;font-weight: bold;">
              学科专业
              <span
                @click="addFun(1)"
                :disabled="operate !== 'add'"
                class="add"
                v-if="operate == 'add'"
              >
                +添加
              </span>
            </span>
          </el-col>
        </el-row>
        <el-row style="position: relative;" v-for="(item, index) in disciplines" :key="index">
          <el-col :span="12">
            <el-form-item label="学科代码1：">
              <el-input
                type="type"
                placeholder="请输入"
                :disabled="operate !== 'add'"
                v-model="item.xkdm"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学科名称1：">
              <el-input
                type="type"
                placeholder="请输入"
                :disabled="operate !== 'add'"
                v-model="item.xkmc"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-button
            type="text"
            style="position: absolute;right: 0;"
            @click="removeFun(item, index, 1)"
            :disabled="operate !== 'add'"
            v-if="disciplines.length !== 1 && operate == 'add'"
          >
            删除
          </el-button>
        </el-row>
        <el-row>
          <el-col :span="6">
            <span style="font-size: 16px;font-weight: bold;">
              国民经济行业
              <span
                @click="addFun(2)"
                :disabled="operate !== 'add'"
                class="add"
                v-if="operate == 'add'"
              >
                +添加
              </span>
            </span>
          </el-col>
        </el-row>
        <el-row
          style="position: relative;"
          v-for="(item, index) in nationalEconomyIndustry"
          :key="index"
        >
          <el-col :span="12">
            <el-form-item label="代码1：">
              <el-input
                type="type"
                :disabled="operate !== 'add'"
                placeholder="请输入"
                v-model="item.xkdm"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称1：">
              <el-input
                type="type"
                :disabled="operate !== 'add'"
                placeholder="请输入"
                v-model="item.xkmc"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-button
            type="text"
            style="position: absolute;right: 0;"
            @click="removeFun(item, index, 2)"
            :disabled="operate !== 'add'"
            v-if="nationalEconomyIndustry.length !== 1 && operate == 'add'"
          >
            删除
          </el-button>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="主要研究方向：">
              <el-input
                type="textarea"
                :disabled="operate !== 'add'"
                :autosize="{ minRows: 6, maxRows: 6 }"
                placeholder="请输入"
                v-model="form.mainResearchDirections"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="受教育情况及工作经历（包括海外学习、工作情况以及在职受教育情况）："
            >
              <el-input
                type="textarea"
                :disabled="operate !== 'add'"
                :autosize="{ minRows: 6, maxRows: 6 }"
                placeholder="请输入"
                v-model="form.educationAndWorkExperience"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="曾经和正在主持或参与承担的主要科技计划（基金）项目：">
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 6 }"
                placeholder="请输入"
                :disabled="operate !== 'add'"
                v-model="form.project"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="主要学术成就（论文、论著、知识产权以及曾获奖励、学术荣誉等）和工作业绩："
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 6 }"
                :disabled="operate !== 'add'"
                placeholder="请输入"
                v-model="form.achievement"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="是否同意参加以下工作：">
              <el-checkbox-group v-model="form.joins">
                <el-checkbox
                  v-for="item in options"
                  :disabled="operate !== 'add'"
                  :key="item.key"
                  :label="item.key"
                >
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="头像"
              style="text-align: left"
              class="file-class"
              label-width="180px"
            >
              <el-upload
                :action="this.uploadURL"
                list-type="picture-card"
                accept=".pdf,.png,.jpg,.jpeg"
                :limit="1"
                :disabled="operate !== 'add'"
                :file-list="fileList"
                :on-preview="handlePictureCardPreview"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="附件" prop="file">
                <el-upload
                  class="upload-demo"
                  :action="this.uploadURL"
                  style="text-align: left"
                  :disabled="operate !== 'add'"
                  :file-list="fileList2"
                  accept=".pdf,.docx,.doc,.xlsx,.xls"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="operate !== 'xq'">
            <el-col :span="24">
              <el-form-item label="审核状态：" prop="approvalStatus">
                <el-select
                  :popper-append-to-body="false"
                  v-model="form.approvalStatus"
                  placeholder="请选择审核状态"
                  style="width: 100%"
                >
                  <!-- <el-option label="待审核" :value="1"></el-option>
            <el-option label="不通过" :value="2"></el-option>
            <el-option label="退回" :value="0"></el-option> -->
                  <el-option label="通过" :value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="审核意见：">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  placeholder="请输入"
                  v-model="auditOpinion"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>

        <el-form-item style="text-align: right">
          <el-button @click="close('form')">
            {{ operate !== 'details' ? '关 闭' : '取 消' }}
          </el-button>

          <el-button type="primary" @click="submit('form')" v-show="operate == 'details'">
            确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" :modal="false">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import Table from './evaluationTable.vue';
import { regionData } from 'element-china-area-data';
import Cookies from 'js-cookie';
export default {
  components: {
    Table
  },
  data() {
    return {
      tableParams: {},
      addroptions: regionData,
      approvalStatus: '',
      auditOpinion: '',
      table: {
        columns: [
          { prop: 'name', label: '姓名' },
          { prop: 'sex', label: '性别', type: 'sex' },
          { prop: 'birthday', label: '出生日期' },
          { prop: 'expertType', label: '专家类型' },
          { prop: 'talentTitle', label: '人才称号' },
          { prop: 'workplace', label: '工作单位' },
          { prop: 'workPhone', label: '联系电话' },
          { prop: 'mobilePhone', label: '手机' },
          { prop: 'email', label: '邮箱' },
          { prop: 'recommendedUnits', label: '推荐单位' },
          { prop: 'jobTitle', label: '职称' },
          { prop: 'expertDatabase', label: '专家库' },
          { prop: 'fieldStudy', label: '研究领域' },
          { prop: 'createTime', label: '申请时间' },
          { prop: 'status', label: '审核状态', type: 'zjrkAuditStatus' }
        ],
        hasBtn: false,
        hasBtn2: true,
        hasSelect: false,
        btns: [
          {
            name: '受理',
            event: 'Acceptance'
          },
          { name: '详情', event: 'details' },
          {
            name: '编辑',
            event: 'editEvent'
          }
        ]
      },
      status: '',
      name: '',
      expertType: '',
      fieldStudy: '',
      jobTitle: '',
      typeOptions: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '0', // 要受理
          label: '待审核'
        },
        {
          value: '1', // 科技主管审核
          label: '审核中'
        },
        {
          value: '3',
          label: '已完成'
        }
      ],
      url: `apij2/admin-api/voucher/expert-registration/page`,
      operate: '',
      form: {
        region: '',
        approvalStatus: ''
      },
      dialogVisible: false,
      fileList: [],
      fileList2: [],
      dialogImageUrl: '',
      dialogFormVisible: false,
      nationalEconomyIndustry: '',
      disciplines: '',
      options: [
        { key: 1, label: '科技战略咨询' },
        { key: 2, label: '项目评审' },
        { key: 3, label: '项目验收' },
        { key: 4, label: '平台认定管理' },
        { key: 5, label: '科技评奖' },
        { key: 6, label: '评价评估' },
        { key: 7, label: '科学普及' },
        { key: 8, label: '科学普及' }
      ],
      rules: {
        approvalStatus: [
          {
            required: true,
            message: '请输入审核状态',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    splistFun(row) {
      // let params = {
      //     "texpertRegistrationId": row.id
      //    }
      this.http
        .get(
          `${urlConfig.devUrl}apij2/admin-api/voucher/expert-registration-record/Detail?texpertRegistrationId=` +
            row.id
        )
        .then(res => {
          if (res.code == 0) {
            this.auditOpinion = res.data.auditOpinion;
            this.form.approvalStatus = res.data.approvalStatus;
            console.log(res.data.auditOpinion, '--res.data.auditOpinion');
          }
        });
    },
    close() {
      this.form.approvalStatus = '';
      this.auditOpinion = '';
      this.dialogFormVisible = false;
    },
    submit(formName) {
      this.$refs[formName].validate((valid, object) => {
        if (valid) {
          let params = {
            texpertRegistrationId: this.form.id,
            auditOpinion: this.auditOpinion,
            approvalStatus: this.form.approvalStatus,
            creatorName: this.form.name,
            creator: Cookies.get('userId'),
            updater: Cookies.get('userId')
          };
          this.http
            .post(
              `${urlConfig.devUrl}apij2/admin-api/voucher/expert-registration-record/approval`,
              params
            )
            .then(res => {
              if (res.code == 0) {
                this.$message.success('审批成功');
                this.dialogFormVisible = false;
                this.$refs.children.seachFun();
                this.search();
              }
            });
        }
      });
    },
    search() {
      this.tableParams = {
        name: this.name,
        status: this.status,
        expertType: this.expertType,
        fieldStudy: this.fieldStudy,
        jobTitle: this.jobTitle,
        page: 1
      };
    },
    acceptanceFun(row) {
      this.$confirm('确定要受理吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = `${
          urlConfig.devUrl
        }apij2/admin-api/voucher/expert-registration/confirm-acceptance?id=${row.id}&status=${1}`;
        this.http.put(url).then(res => {
          if (res.data) {
            this.url = `apij2/admin-api/voucher/expert-registration/page?index=1`;
            this.$refs.children.seachFun();
            this.seachFun();
            this.$message({
              message: '受理成功',
              type: 'success'
            });
          }
        });
      });
    },
    detailsFun(row) {
      this.form = { ...row };
      this.form.joins = row.joins ? row.joins.split(',').map(Number) : [];
      this.disciplines = JSON.parse(row.disciplines);
      this.form.region = JSON.parse(row.region);
      this.nationalEconomyIndustry = JSON.parse(row.nationalEconomyIndustry);
      this.fileList = row.avatar
        ? [
            {
              name: row.avatar.split('!')[1],
              url: 'https://devfile.gsisc.cn/' + row.avatar
            }
          ]
        : [];

      this.fileList2 = row.appendix
        ? [
            {
              name: row.appendix.split('!')[1],
              url: 'https://devfile.gsisc.cn/' + row.appendix
            }
          ]
        : [];
      this.dialogImageUrl = row.avatar;
      this.operate = 'xq';
      this.dialogFormVisible = true;
    },
    editFun(row) {
      this.form = { ...row };
      this.form.joins = row.joins ? row.joins.split(',').map(Number) : [];
      console.log(this.form.joins, row.joins, '---d');
      this.disciplines = JSON.parse(row.disciplines);
      this.form.region = JSON.parse(row.region);
      this.addroptions.forEach(item => {
        if (item.value == this.form.region[0]) {
          this.form.regionName = item.label;
        }
      });
      this.nationalEconomyIndustry = JSON.parse(row.nationalEconomyIndustry);
      this.fileList = row.avatar
        ? [
            {
              name: row.avatar.split('!')[1],
              url: 'https://devfile.gsisc.cn/' + row.avatar
            }
          ]
        : [];

      this.fileList2 = row.appendix
        ? [
            {
              name: row.appendix.split('!')[1],
              url: 'https://devfile.gsisc.cn/' + row.appendix
            }
          ]
        : [];
      this.dialogImageUrl = row.avatar;
      this.operate = 'details';
      this.dialogFormVisible = true;
      this.splistFun(row);
    }
  }
};
</script>

<style lang="scss" scoped>
@include component(business-evaluation) {
  width: 100%;

  // padding: 30px;
  @include part(header) {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;

    .el-input {
      width: 400px;
      margin: 0 15px;
    }
  }

  @include part(step) {
    width: 100%;
    margin: 0 auto;
  }

  @include part(dialog) {
    padding: 30px 50px;
  }

  /deep/.evaluation_dialog {
    border-radius: 6px;
    .el-dialog__header {
      border-radius: 6px 6px 0 0;
      background: #fff !important;
      .header-title {
        position: relative;
        height: 100%;
        line-height: 50px;
        text-align: left;
        padding: 0 0 0 26px;
        font-weight: 600;
        font-size: 16px;

        &::before {
          content: '';
          position: absolute;
          width: 10px;
          height: 20px;
          background-color: #428dff;
          left: 0;
          top: 50%;
          transform: translate(0, -50%);
        }
      }
    }

    .el-dialog__body {
      .evaluation_dialog_top {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .satisfaction {
          font-size: 28px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: #333333;
          line-height: 48px;
          text-align: center;
        }
        .el-rate {
          margin-top: 14px;
          i {
            font-size: 32px;
            margin-right: 18px;
          }
        }
      }
      .evaluation_dialog_content {
        margin-top: 46px;
        .content {
          margin-top: 10px;
          textarea {
            min-height: 100px !important;
          }
        }
      }
    }
  }
  .el-dialog__header {
    border-radius: 6px 6px 0 0;
    background: #fff !important;
    padding: 1px 0 0 0;
    .header-title {
      display: flex;
      width: 100%;
      position: relative;
      height: 100%;
      line-height: 50px;
      text-align: left;
      padding: 0 0 0 26px;
      font-weight: 600;
      font-size: 16px;
      justify-content: space-between;

      &::before {
        content: '';
        position: absolute;
        width: 10px;
        height: 20px;
        background-color: #428dff;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
      }
      i {
        cursor: pointer;
        margin-right: 10px;
      }
    }
  }
}
</style>
